import { createNumberFormatter } from '@icommerce/i18n';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

type LifetimeProps = {
  lifetime: number;
  maxLifeTimeReference: number;
};

export const LifetimeBar = ({ lifetime, maxLifeTimeReference }: LifetimeProps) => {
  const { t } = useTranslation(['category/productFilter', 'common']);
  const router = useRouter();
  const { locale } = router;
  const lifetimeFactor = Math.round((Math.sqrt(lifetime) / Math.sqrt(maxLifeTimeReference)) * 102);

  return (
    <div className="relative">
      <div>
        {Math.ceil(lifetime) < 0 ? (
          <span className="whitespace-nowrap">
            {t(`COMMON.UPON_REQUEST`, { ns: 'free-form-hub/freeFormHubCommon' })}
          </span>
        ) : (
          <span className="whitespace-nowrap">{createNumberFormatter(locale).format(Math.ceil(lifetime))} h</span>
        )}
      </div>
      <div>
        {Math.ceil(lifetime) >= 0 && (
          <div className="right-12 rounded-full w-[80px] h-[4px] mr-4 mt-1 bg-[#C8DFE9]">
            <div
              data-testid="progress-bar"
              className="absolute left-0 rounded-full h-[4px] bg-[#2480A8]"
              style={{
                width: `${lifetimeFactor}px`,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
